import { MenuProps } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent, SelectProps } from '@mui/material/Select';
import React from 'react';

export type { SelectChangeEvent };

export interface SelectOption {
  value: string | number;
  name: string;
}

interface CustomSelectProps<T> extends SelectProps<T> {
  options: SelectOption[];
  selectRef?: React.Ref<HTMLDivElement> | null;
}

export const SelectMenuProps: Partial<MenuProps> = {
  variant: 'menu',
  disableScrollLock: true,
  TransitionProps: { timeout: { enter: 0, exit: 0 } }
};

const CustomSelect = <T,>({ options, selectRef, ...props }: CustomSelectProps<T>) => (
  <Select {...props} ref={selectRef} MenuProps={SelectMenuProps}>
    {options?.map((option) => (
      <MenuItem value={option.value} key={option.value}>
        {option.name}
      </MenuItem>
    ))}
  </Select>
);

export default CustomSelect;
